module.exports = __webpack_public_path__ + "img/WIfi机.5d65398e.jpg";